module.exports = __webpack_public_path__ + "static/img/nodata-video.e7055e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nodata-video.png
// module id = Iopt
// module chunks = 1